<template>
  <div class="v-stepper">
    <component :is="rootComponent" class="flex-wrap">
      <v-step
        v-for="(step, $index) in stepsArr"
        :name="id"
        :key="$index"
        :debug="debug"
        :index="$index"
        :visited="step.visited"
        :disabled="step.disabled"
        :with-divider="withDivider"
        :active="step.index === toIndex(value)"
        @change="handleChange"
      >
        <!-- @change="handleChange" -->
        <div>{{ $index }}</div>
        <template slot="index" slot-scope="api">
          <slot :name="`step-${api.displayIndex}-index`" v-bind="api">
            {{ api.displayIndex }}
          </slot>
        </template>
        <template slot-scope="api">
          <slot :name="`step-${api.displayIndex}`" v-bind="api"></slot>
        </template>
      </v-step>
    </component>
  </div>
</template>

<script>
// https://www.webpackbin.com/bins/-KvHS7KEmrTLJOYWS9k2
// https://material.angular.io/components/stepper/overview
// https://cristijora.github.io/vue-form-wizard/#/?id=demos
// https://stackoverflow.com/questions/4852017/how-to-initialize-an-arrays-length-in-javascript

// Components
import VStep from './Step'
import VStepperRoot from './StepperRoot'

// Implementation
export default {
  name: 'Stepper',
  components: {
    VStep,
  },
  props: {
    value: {
      type: Number,
      default: 1,
    },
    steps: {
      required: true,
    },
    linear: {
      type: Boolean,
      default: true,
    },
    // todo: add strict mode
    // strict: {
    //   type: Boolean,
    //   default: true
    // },
    edit: {
      type: Boolean,
      default: false,
    },
    persist: {
      type: Boolean,
      default: false,
    },
    storekeeper: {
      type: String,
      default: 'localStorage',
      validator(value) {
        return ['localStorage', 'sessionStorage'].includes(value)
      },
    },
    withDivider: {
      type: Boolean,
      default: true,
    },
    rootComponent: {
      type: Object,
      default: () => VStepperRoot,
    },
    debug: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      namespace: 'v-stepper',
      stepsArr: [],
      index: this.toIndex(this.value),
    }
  },
  watch: {
    value(value) {
      this.index = this.toIndex(value)
      if (this.persist) {
        this.setStorage()
      }
    },
    index: {
      handler(index) {
        console.log('index = ', index)
        //this.$emit("input", this.toValue(index));
      },
      immediate: true,
    },
  },
  created() {
    if (this.persist) {
      const storage = this.getStorage()
      if (storage) {
        this.stepsArr = storage.stepsArr
        this.index = storage.index
      } else {
        this.setStorage()
      }
    }
  },
  destroyed() {
    window[this.storekeeper].removeItem(this.id)
  },
  computed: {
    id() {
      return `${this.namespace}-${this._uid}`
    },
    lastIndex() {
      return this.stepsArr.length - 1
    },
  },
  methods: {
    changeStepsArr(data) {
      this.stepsArr = data
    },
    toValue(index) {
      return index + 1
    },
    toIndex(value) {
      return value - 1
    },
    doesStepExist(index) {
      return !!this.stepsArr[index]
    },
    isIntermediateIndex(index) {
      return index > 0 && index < this.lastIndex
    },
    enoughMove(index) {
      const isNext = index === this.index + 1
      const isPrevious = index === this.index - 1
      const oldIndex = this.toIndex(this.value)

      if (this.linear) {
        if (isNext || isPrevious) {
          this.setStep(index, 'active', true)
          this.setStep(oldIndex, 'active', false)
          this.$emit('input', this.toValue(index))
        } else {
          this.setStep(index, 'active', true)
          this.setStep(oldIndex, 'active', false)
          this.$emit('input', this.toValue(index))
        }
      } else {
        this.setStep(oldIndex, 'visited', true)
        this.$emit('input', this.toValue(index))
      }
    },
    handleChange(index) {
      const isNext = index === this.index + 1
      const isPrevious = index === this.index - 1
      const oldIndex = this.toIndex(this.value)
      this.$emit('errors', oldIndex, index, isNext, isPrevious)
      return
    },
    getMap() {
      return Array.from(this.steps, (step, idx) => {
        const index = idx - 1
        const disabled = step.disabled
        const visited = step.visited
        const value = this.toValue(idx)

        return { index, value, visited, disabled }
      })
    },
    offset(offset) {
      const index = this.index + offset
      if (this.doesStepExist(index)) {
        this.handleChange(index)
      }
    },
    next() {
      this.offset(1)
    },
    nextWithBtn() {
      const index = this.index + 1
      if (this.doesStepExist(index)) {
        //console.log('oldIndex = ' , oldIndex , '  ' . isNext , ' ' , index)
        // todo: add strict mode
        // strict mode: navigate if only prev || next step is available
        // but only programmatically allowed to change step

        // lenear mode: navigate if only prev || next step is available
        const isNext = index === this.index + 1
        const isPrevious = index === this.index - 1
        const oldIndex = this.toIndex(this.value)

        if (this.linear) {
          if (isNext || isPrevious) {
            this.setStep(index, 'active', true)
            this.setStep(index, 'visited', false)
            this.setStep(index, 'disabled', true)

            this.setStep(oldIndex, 'active', false)
            this.setStep(oldIndex, 'visited', true)
            this.setStep(oldIndex, 'disabled', false)

            this.$emit('getSteps', this.stepsArr, index)
            //this.$emit("input", this.toValue(index));
          } else {
            this.setStep(index, 'active', true)
            this.setStep(index, 'visited', false)
            this.setStep(index, 'disabled', true)

            this.setStep(oldIndex, 'active', false)
            this.setStep(oldIndex, 'visited', true)
            this.setStep(oldIndex, 'disabled', false)

            this.$emit('getSteps', this.stepsArr, index)
            //this.$emit("input", this.toValue(index));
          }
        } else {
          this.setStep(oldIndex, 'visited', true)
          this.$emit('input', this.toValue(index))
        }
      }
    },
    previous() {
      this.offset(-1)
    },
    reset() {
      this.stepsArr = this.getMap()
      this.index = 0
      this.$emit('reset')
    },
    setStep(index, prop, value) {
      this.$set(this.stepsArr[index], prop, value)
    },
    setStorage() {
      const { index, stepsArr } = this
      window[this.storekeeper].setItem(
        this.id,
        JSON.stringify({ index, stepsArr })
      )
    },
    getStorage() {
      return JSON.parse(window[this.storekeeper].getItem(this.id))
    },
  },
  inheritAttrs: false,
}
</script>
